import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    columnHeader: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    columnsContainer: {
        alignItems: "flex-start",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    emptyContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    columnWrapper: {
        flexDirection: "column",
        flex: 1
    },
    container: {
        flexDirection: "column"
    },
    listContainer: {
        flexDirection: "column"
    },
    columnTitleContainer: {
        flexDirection: "row",
        alignItems: "center"
    }
});
export default stylesheet;
